export default ({
  name: 'cacs',
  theme: {
    base: {
      chart: {
        use3DLighting: '0',
        baseFont: 'Roboto',
        decimals: '2',
        forceDecimals: '1',
        baseFontSize: '12',
        exportEnabled: '1',
        exportFormats: 'PNG=Export PNG File|PDF=Export PDF File|SVG=Export SVG for PowerPoint|XLSX=Export XLSX for Excel|CSV=Export CSV for Excel',
        exportMode: 'client',
        exportFilename: 'CACS_Export',
        bgColor: '#ffffff',
        showBorder: '0',
        canvasBorderColor: '#e7e7e7',
        canvasBorderThickness: '1',
        usePlotGradientColor: '0',
        plotBorderColor: '#eeeeee',
        plotBorderThickness: '1',
        paletteColors: '#e07670',
        captionFontSize: '16',
        captionPadding: '20',
        subCaptionFontSize: '12',
        captionFontBold: '1',
        subCaptionFontBold: '0',
        captionAlignment: 'left',
        captionFont: 'Roboto',
        captionFontColor: '#0d0d0d',
        subCaptionFontColor: '#717171',
        alignCaptionWithCanvas: '1',
        xAxisNameFont: 'Roboto',
        xAxisNameFontColor: '#4a4a4a',
        xAxisNameFontSize: '12',
        xAxisNameFontBold: '1',
        xAxisNamePadding: '20',
        yAxisNameFont: 'Roboto',
        yAxisNameFontColor: '#4a4a4a',
        yAxisNameFontSize: '12',
        yAxisNameFontBold: '1',
        yAxisNamePadding: '20',
        showHoverEffect: '1',
        divLineColor: '#e7e7e7',
        alternateVGridColor: '#dcdcdc',
        canvasRightPadding: '20',
        showValues: '1'
      }
    },
    sankey: {
      chart: {
        nodeLabelFontColor: '#666',
        nodeLabelFontSize: 14,
        nodeLabelPosition: 'inside',
        legendPosition: 'bottom',
        plothighlighteffect: 'fadeout',
        linkColor: 'source',
        textOutline: 1,
        enableDrag: 0
      }
    },
  }
});
